<template>
    <div :class="wrapClasses">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
          error: String
        },
        computed: {
            wrapClasses() {
                return 'form-input' + (this.error ? ' has-error' : '');
            }
        }
    }
</script>
